<script>
  import Section from '../components/Section.svelte';
  import Panel from '../components/Panel.svelte';
  import Button from '../components/Button.svelte';
  import Stepper from '../components/Stepper.svelte';
  import Async from '../components/Async.svelte';
  import HelpDrawer from '../components/HelpDrawer.svelte';
  import { draft } from '../lib/partnerDraft.svelte.js';
  import { getConfig } from '../lib/api.js';
  import { themeGroups } from '../lib/slices.js';
  import { HELP } from '../lib/help.js';

  const steps = ['Partner details', 'What you share', 'Review'];
  // aggregations.json read live from the Pod — the themes offered here are
  // derived from the flat aggregates[] (per-aggregate theme tag), not a
  // build-time import.
  const aggregationsPromise = getConfig('aggregations');
</script>

<HelpDrawer {...HELP['partner/access']} />

<h1 class="wf2-title wf2-title-level-1">Add sharing partner</h1>
<Stepper {steps} active={1} />

<Section title="What you share with them (optional)">
  <Panel>
    <p class="wf2-text">
      Pick the themes to share, then continue to review. You share whole
      <strong>themes</strong>, never individual records — a theme is a group of
      cubes that travel together, with privacy rules for when small counts are
      left out. Choose what
      <strong>{draft.name || 'this partner'}</strong> gets.
    </p>

    <Async promise={aggregationsPromise} loading="Reading themes from your Pod…">
      {#snippet children(aggregations)}
    {#each themeGroups(aggregations) as theme}
      <div class="wf2-panel" style="margin-top: var(--space-3)">
        <div class="wf2-checkline">
          <input class="wf2-check" type="checkbox" id={theme.name} bind:checked={draft.themes[theme.name]} />
          <label for={theme.name}>
            <strong><span class="tag {theme.name}">{theme.name}</span></strong>
            — hide counts under {theme.suppressBelow},
            {theme.sharing.mode === 'mutual'
              ? 'shared both ways'
              : (theme.sharing.to ?? []).length
                ? `given to ${theme.sharing.to.join(', ')}, nothing back`
                : 'currently private'}
          </label>
        </div>
        <div class="wf2-tablewrap" style="overflow-x:auto">
          <table class="wf2-table">
            <thead><tr><th>Cube</th><th>Breaks down by</th><th>What it counts</th></tr></thead>
            <tbody>
              {#each theme.slices as s}
                <tr>
                  <td class="mono">{s.dataSet}</td>
                  <td class="mono">{s.dimensions.join(', ')}</td>
                  <td class="mono">{s.reducer} {s.measure}{#if s.suppressMeasureBelow !== null} · hide totals under {s.suppressMeasureBelow}{/if}</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    {/each}
      {/snippet}
    </Async>

    <p class="wf2-hint">
      They get only the cubes listed under the themes you select. Your private
      records and every unselected cube stay in your Pod.
      Select nothing if you only want to receive from this partner and give
      nothing back. See the “?”.
    </p>
  </Panel>
</Section>

<div class="wf2-row" style="gap:12px">
  <Button variant="primary" to="partner/confirm">Next: review</Button>
  <Button variant="secondary" to="partner">Back</Button>
</div>
